import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "../../api";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const signinApi = createApi({
  reducerPath: reducerPaths.signinApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    signin: builder.query({
      query: ({ endpoint, phone }) => ({
        url: `/auth/dealer/login?phone=${phone}`,
        method: "POST",
      }),
    }),
    verifyOtpHandler: builder.mutation({
      query: ({ endpoint, payload }) => ({
        url: `/auth/dealer/verifylogin`,
        method: "POST",
        body: payload,
      }),
    }),
    logout: builder.mutation({
      query: ({ payload }) => ({
        url: "/auth/seller/logout",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useSigninQuery, useVerifyOtpHandlerMutation, useLogoutMutation } =
  signinApi;

export const { useLazySigninQuery } = signinApi;
